import type { GameProduct, GameTypes } from '@patrianna/shared-patrianna-types/store/GameModule'

import ROUTES from 'config/routes.json'
import type { SupportedCurrencies } from 'types/currencies'

export const getSlotBetsAndPrizes = (game: GameProduct, activeCurrency: SupportedCurrencies) => {
  if (game && activeCurrency) {
    const {
      sweepstakeMinBet,
      goldMinBet,
      sweepstakeMaxBetMultiplier,
      goldMaxBetMultiplier,
      sweepstakeMaxWinMultiplier,
      goldMaxWinMultiplier,
    } = game
    const maxWinMultipliers = {
      SC: sweepstakeMaxWinMultiplier,
      GC: goldMaxWinMultiplier,
    }
    const minBetMultipliers = {
      SC: sweepstakeMinBet,
      GC: goldMinBet,
    }
    const maxBetMultipliers = {
      SC: sweepstakeMaxBetMultiplier,
      GC: goldMaxBetMultiplier,
    }

    return {
      minBet: minBetMultipliers[activeCurrency],
      maxBet: minBetMultipliers[activeCurrency] * maxBetMultipliers[activeCurrency],
      maxPrize:
        minBetMultipliers[activeCurrency] * maxBetMultipliers[activeCurrency] * maxWinMultipliers[activeCurrency],
      maxWinMultiplier: sweepstakeMaxWinMultiplier,
    }
  }

  return null
}

export const hasAllInfoBlocks = (game: GameProduct, activeCurrency: SupportedCurrencies, isLoggedIn: boolean) => {
  const showGameType = Boolean(game) && game.type !== 'scratch_card'

  return (
    isLoggedIn &&
    showGameType &&
    Boolean(game?.volatility) &&
    Boolean(game?.orientation) &&
    Boolean(getSlotBetsAndPrizes(game, activeCurrency))
  )
}

export const getGameTypeData = (game: GameProduct) => {
  let gameType
  let categoryLink
  const isTableGame = game?.code === 'bjma' || game?.code === 'evo_5553'

  switch (game?.type as GameTypes | 'in_house') {
    case 'in_house':
      gameType = 'Casual Games'
      categoryLink = ROUTES.GAMES_CASUAL
      break

    default:
      gameType = 'Online Slots'
      categoryLink = ROUTES.GAMES_SLOTS
      break
  }

  if (isTableGame) {
    gameType = 'Table Games'
    categoryLink = ROUTES.GAMES_TABLE
  }

  if ((game.tags ?? []).includes('SLI')) {
    gameType = 'Slingo'
    categoryLink = ROUTES.GAMES_SLINGO
  }

  return { gameType, categoryLink }
}

export const getGridOptions = (countOfBlocks: number) => {
  return {
    isOdd: countOfBlocks % 2 !== 0,
    isSmall: countOfBlocks === 5 || countOfBlocks === 6,
  }
}
